import React, { useState, useEffect, useRef, useCallback } from "react";
import { ReactComponent as CloseModal } from "../../assets/svg/close-modal.svg";
import WebSiteSearchModal from "../common/website-search-model";

export default function WebSiteEditModal({ open, editUrl = '', onClose, onSubmit, url }) {

    const [websiteUrl, setWebsiteUrl] = useState(editUrl || '');
    const [isActive, setIsActive] = useState(false);
    const [isInputDisabled, setIsInputDisabled] = useState(false);


    useEffect(() => {
        if (open) {
            setWebsiteUrl(editUrl || "");
        }
    }, [open, editUrl]);
   

    if (!open) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999
            }}
            onClick={onClose} // 👉 clicking outside closes modal
        >
            <div
                style={{
                    backgroundColor: "#FFFFFF",
                    width: "812px",
                    borderRadius: "16px",
                    overflow: "hidden"
                }}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
            >
                {/* HEADER */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#172B4D",
                        border: "1px solid #EBEBEB",
                        backgroundColor: "#F5F7F9",
                        width: "100%",
                        padding: "12px 20px"
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ fontSize: "16px", fontWeight: "500", marginLeft: "10px" }}>
                            Website Link
                        </div>
                    </div>

                    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <CloseModal
                            onClick={(e) => { e.stopPropagation(); onClose(); }}
                            style={{ cursor: "pointer" }} />
                    </div>
                </div>
                <div style={{ alignItems: "center", padding: '24px' }}>

                    <div style={{ fontWeight: "600", fontSize: "16px", color: "#172B4D", marginBottom: "8px" }}>
                        Paste Link
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "60%",
                        }}
                    >
                        <input
                            type="url"
                            value={websiteUrl}
                            onFocus={() => setIsActive(true)}
                            onBlur={() => setIsActive(false)}
                            disabled={isInputDisabled}
                            onChange={(e) => setWebsiteUrl(e.target.value)}
                            style={{
                                height: "40px",
                                borderRadius: "10px",
                                border: isActive ? "1px solid #3D6DFF" : "0.6px solid #d4dde7",
                                backgroundColor: isInputDisabled ? "#F8F8F8" : "#ffffff",
                                padding: "0px 38px 0px 12px",
                                width: "100%",
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#172b4d",
                                outline: "none",
                            }}
                            placeholder="https://example.com"
                        />
                    </div>
                </div>

                {/* FOOTER BUTTONS */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "16px 24px",
                        borderTop: "1px solid #EBEBEB",
                        backgroundColor: "#fff"
                    }}
                >
                    <button
                        onClick={() => onSubmit(true, websiteUrl)}
                        style={{
                            padding: "10px 24px",
                            backgroundColor: "#3D4AF5",
                            color: "#fff",
                            borderRadius: "8px",
                            border: "none",
                            fontWeight: 600,
                            cursor: "pointer"
                        }}
                    >
                        Search
                    </button>
                </div>
            </div>
        </div>
    );
}
